/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import MDButton from 'components/MDButton'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import EditModal from '../../EditModal'
import CreateModal from '../../CreateModal'
import { useNavigate, useParams } from 'react-router-dom'
export default function DataTableData() {
  const AppService = useAppServices()
  const [list, setList] = useState([])
  const [loader, setLoader] = useState(true)
  const [awards, setAwards] = useState([])
  const [questions, setQuestions] = useState([])
  const [category, setCategory] = useState([])
  const { chapter_id, type } = useParams()
  const navigate = useNavigate()

  const getAppTypes = async () => {
    console.log('chapter_id', chapter_id)
    const { response } = await AppService.questions_chapters.filter({
      query: `chapter_id=${type}`,
      toaster: false,
    })
    if (response) {
      setList(response.data)
    } else {
      setList([])
    }
    setLoader(false)
  }
  const getAwards = async () => {
    const { response } = await AppService.award_list.get()
    // console.log(response, 'request_app')
    if (response) {
      setAwards(response.data)
    } else {
      setAwards([])
    }
  }
  const getCategories = async () => {
    const { response } = await AppService.questions_sections.get()
    // console.log(response, 'request_app')
    if (response) {
      setCategory(response.data)
    } else {
      setCategory([])
    }
  }

  const getQuestions = async () => {
    const { response } = await AppService.questions.get()
    if (response) {
      setQuestions(response.data)
    } else {
      setQuestions([])
    }
  }

  const onLoad = () => {
    getAppTypes()
    getAwards()
    getQuestions()
    getCategories()
  }

  const handleDelete = async (id) => {
    const { response } = await AppService.questions_chapters.delete({
      query: `_id=${id}`,
    })
    if (response) onLoad()
  }

  useEffect(onLoad, [])

  return {
    awards,
    questions,
    category,
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        // { Header: "chapter_id", accessor: "chapter_id" },
        { Header: "question", accessor: "question" },
        { Header: "answer", accessor: "answer" },
        { Header: "priority", accessor: "priority" },
        { Header: "points", accessor: "points" },
        { Header: "type", accessor: "type" },
        { Header: "status", accessor: "status" },
        { Header: "Action", accessor: "action" },
      ],
      rows: list.map((data) => ({
        question: data.question,
        answer: data.answer ? "Yes" : "No",
        priority: data.priority,
        points: data.points,
        type: data.type,
        status: data.status,

        action: (
          <MDBox>
            <EditModal data={data} handleRefresh={onLoad} awards={awards} questions={questions} category={category} />

            <MDButton
              variant="contained"
              color="error"
              size="small"
              sx={{ marginLeft: 2 }}
              onClick={() => handleDelete(data._id)}
            >
              Delete
            </MDButton>
          </MDBox>
        ),
      })),
    },
  }
}
